export default {
  'ss.home': 'Trang chủ',
  'ss.specialServices': 'Dịch vụ đặc biệt',
  'ss.planTitleA': 'Lên kế hoạch cho',
  'ss.planTitleB': 'chuyến đi trong mơ',
  'ss.planSubtitle': 'Hãy kể đôi chút về hành trình lý tưởng của bạn và chuyên gia địa phương sẽ phản hồi trong 24 giờ với kế hoạch được thiết kế riêng — không khuôn mẫu, không sao chép.',
  'ss.replyTitle': 'Phản hồi trong 24 giờ',
  'ss.replyDesc': 'Một chuyên gia thực sự xem xét yêu cầu của bạn — không phải phản hồi tự động.',
  'ss.pricingTitle': 'Giá minh bạch',
  'ss.pricingDesc': 'Mỗi đề xuất đều kèm bảng phân tích rõ ràng — không phí ẩn.',
  'ss.adjustTitle': 'Điều chỉnh miễn phí',
  'ss.adjustDesc': 'Chúng tôi tinh chỉnh kế hoạch cho đến khi đúng như bạn tưởng tượng.',
  'ss.formTitle': 'Bắt đầu lên kế hoạch',
  'ss.formSubtitle': 'Điền vào biểu mẫu và chúng tôi sẽ thiết kế lịch trình cho bạn.',
  'ss.fullName': 'Họ và tên',
  'ss.email': 'Email',
  'ss.phone': 'Điện thoại / WhatsApp',
  'ss.fullAddress': 'Địa chỉ đầy đủ',
  'ss.destination': 'Điểm đến',
  'ss.travelDate': 'Ngày đi',
  'ss.groupSize': 'Quy mô đoàn',
  'ss.budget': 'Ngân sách mỗi người',
  'ss.travelIdeas': 'Ý tưởng du lịch của bạn',
  'ss.yourName': 'Tên của bạn',
  'ss.emailPlaceholder': 'ban@example.com',
  'ss.phonePlaceholder': '+84 ...',
  'ss.addressPlaceholder': 'Đường, thành phố, quốc gia...',
  'ss.messagePlaceholder': 'Hãy kể về chuyến đi lý tưởng của bạn — điều bạn yêu thích, ai sẽ đi cùng, và bất cứ điều đặc biệt nào bạn muốn đưa vào...',
  'ss.destNotSure': 'Chưa chắc chắn',
  'ss.destNorth': 'Miền Bắc Việt Nam (Hà Nội, Sapa, Hạ Long)',
  'ss.destCentral': 'Miền Trung Việt Nam (Hội An, Huế, Đà Nẵng)',
  'ss.destSouth': 'Miền Nam Việt Nam (TP.HCM, Đồng bằng sông Cửu Long)',
  'ss.destWhole': 'Toàn bộ Việt Nam',
  'ss.groupSolo': '1 (một mình)',
  'ss.groupCouple': '2 (cặp đôi)',
  'ss.group3to5': '3 - 5',
  'ss.group6to10': '6 - 10',
  'ss.group10plus': '10+',
  'ss.budgetUnder500': 'Dưới $500',
  'ss.budget500to1000': '$500 - $1.000',
  'ss.budget1000to2000': '$1.000 - $2.000',
  'ss.budget2000plus': '$2.000+',
  'ss.sending': 'Đang gửi...',
  'ss.planMyTrip': 'Lên kế hoạch chuyến đi',
  'ss.success': 'Cảm ơn bạn! Chuyên gia địa phương sẽ phản hồi trong vòng 24 giờ với kế hoạch được thiết kế riêng.',
  'ss.sendFailed': 'Không thể gửi yêu cầu. Vui lòng thử lại.',
  'ss.networkError': 'Đã xảy ra lỗi mạng. Vui lòng thử lại.',
  'ss.heroAlt': 'Dịch vụ đặc biệt Việt Nam',
  'ss.heroTitle': 'Dịch vụ đặc biệt du lịch Việt Nam',
  'ss.ctaAlt': 'Dịch vụ đặc biệt Việt Nam',
  'ss.ctaTitle': 'Dịch vụ đặc biệt Vietnam Travel',
  'ss.visaAlt': 'Hỗ trợ visa Việt Nam',
  'ss.visaTitle': 'Dịch vụ hỗ trợ visa Việt Nam',
  'ss.captchaRequired': 'Vui lòng xác nhận bạn không phải robot.',
  'ss.captchaFailed': 'Xác minh bảo mật thất bại. Vui lòng thử lại.',
};